<template>
    <div class="container-fluid fixed-height" id="viewPortfolio">
        <div style="margin-bottom: 20px;">
            <div class="author">
                <div class="profile">
                    <img src="../assets/boy.png" v-if="profileImage === ''">
                    <img v-if="profileImage !== ''" :src="`data:image/jpg;base64, ${profileImage}`"/>
                </div>

                <div class="feed-heading">
                    <span style="font-weight: normal;">{{postCreatorName}}</span>
                    <small class="date"><i class="fa fa-clock-o" aria-hidden="true"></i>
                        {{postCreatorDate}}
                    </small>
                </div>
            </div>
            <div v-html="postTitle">

            </div>
        </div>
        <div v-if="file.length>0">
            <b-carousel style="text-shadow: 1px 1px 2px #333;"
                        :controls="file.length>1"
                        indicators
                        background="#ababab"
                        :interval="0">
                <div>
                    <b-carousel-slide v-for="(tempObjArrayFiles, fileIndex) of file">
                        <img v-if="getFileExtType(tempObjArrayFiles) === 'IMAGE'"
                             slot="img"
                             class="card-img-top d-block img-fluid w-100"
                             :src="getHighSource(tempObjArrayFiles)"/>

                        <LazyVideo v-else-if="getFileExtType(tempObjArrayFiles) === 'VIDEO'"
                                   slot="img"
                                   class="card-img-top d-block img-fluid"
                                   style="margin: 0 auto; width: 70%; height: 120px;"
                                   :src="getHighSource(tempObjArrayFiles)" />

                        <audio v-else-if="getFileExtType(tempObjArrayFiles) === 'AUDIO'"
                               slot="img" class="card-img-top d-block img-fluid"
                               controls
                               style="margin: 0 auto; width: 70%; height: 120px;">
                            <source :src="getHighSource(tempObjArrayFiles)" :type="tempObjArrayFiles.PostItemFileType">
                        </audio>

                        <pdf slot="img" class="card-img-top d-block img-fluid"
                             v-if="getFileExtType(tempObjArrayFiles) === 'PDF'"
                             v-for="i in tempObjArrayFiles.numPages" :key="i" :page="i"
                             :src="tempObjArrayFiles.pageOfSrc" style="height: 100%; overflow-y: auto; overflow-x: hidden;"></pdf>
                    </b-carousel-slide>
                </div>
            </b-carousel>
        </div>
        <div v-if="file.length<1">
            <div class="col-lg-12">
                <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    "use strict";
    import DataSource from "../data/datasource";
    import pdf from 'vue-pdf';
    import VueLazyLoadVideo from 'vue-lazyload-video';
    import Vue from 'vue';
    Vue.use(VueLazyLoadVideo);
    import GlobalFn from "../components/GlobalFn";

    export default {
        name: "viewPortfolioComponent",
        data() {
            return {
                mode: '',
                profileImage: '',
                postCreatorName: '',
                postCreatorDate: '',
                file: [],
                postTitle: '',
            };
        },
        components: {pdf},
        props: ["parentPost"],
        async created() {
            await this.arrangeData();
        },
        async mounted() {
        },
        methods: {
            async arrangeData(){
                this.mode = this.parentPost.dsOverAll.dsOverAll[0].Type;

                if (this.mode === 'Post') {
                    if (this.parentPost.dsKgm_Post.Table[0].ProfileImage) {
                        this.profileImage = this.parentPost.dsKgm_Post.Table[0].ProfileImage;
                    }

                    this.postCreatorName = this.parentPost.dsKgm_Post.Table[0].CONname;
                    this.postCreatorDate = this.parentPost.dsKgm_Post.Table[0].PostCreatedDate_convert;
                    this.postTitle = this.parentPost.dsKgm_Post.Table[0].PostUpdDtlDescription;

                    await Promise.all([this.parentPost.dsKgm_PostItem]).then((result) => {
                        result[0].Table.forEach(file => {
                            if (file.PostItemFileExt.toLowerCase() === ".pdf") {
                                file.numPages = undefined;

                                let src = pdf.createLoadingTask(file.FilePath);
                                file.pageOfSrc = src;
                                src.promise.then(pdf => {
                                    file.numPages = pdf.numPages;
                                });
                            }

                            this.sleep(200);
                        });
                    });

                    await this.sleep(200);

                    this.file = this.parentPost.dsKgm_PostItem.Table;
                } else if (this.mode === 'Portfolio') {
                    if (this.parentPost.dsKgm_Portfolio.Table[0].ProfileImage) {
                        this.profileImage = this.parentPost.dsKgm_Portfolio.Table[0].ProfileImage;
                    }

                    this.postCreatorName = this.parentPost.dsKgm_Portfolio.Table[0].CONname;
                    this.postCreatorDate = this.parentPost.dsKgm_Portfolio.Table[0].PortfolioCreatedDate_convert;
                    this.postTitle = this.parentPost.dsKgm_Portfolio.Table[0].PortfolioTitle;

                    let tempFile = [];
                    let tempFilePath = {
                        FilePath: this.parentPost.dsKgm_Portfolio.Table[0].FilePath,
                        PostItemFileExt: '.pdf',
                    };
                    tempFile.push(tempFilePath);

                    tempFile[0].numPages = undefined;
                    let src = pdf.createLoadingTask(tempFile[0].FilePath);
                    tempFile[0].pageOfSrc = src;
                    src.promise.then(pdf => {
                        tempFile[0].numPages = pdf.numPages;
                    });

                    this.file = tempFile;
                }
            },
            /*#region Select Gallery From Components*/
            isImage(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },
            isVideo(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isVideo = false;

                switch (ext) {
                    case ".MP4":
                        isVideo = true;
                        break;
                    default:
                        isVideo = false;
                        break;
                }

                return isVideo;
            },
            isAudio(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isAudio = false;

                switch (ext) {
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                        isAudio = true;
                        break;
                    default:
                        isAudio = false;
                        break;
                }

                return isAudio;
            },
            getHighSource(file) {
                // if (this.isImage(file))
                //     return "data:" + file.PostItemFileType + ";base64," + file.PostItemFile;
                // else
                //     return "";
                // return "data:" + file.PostItemFileType + ";base64," + file.PostItemFile;
                return file.FilePath;
            },
            /*#endregion*/
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
            getFileExtType(obj_File){
                let fileTypeExt = GlobalFn.FileType(obj_File.PostItemFileExt);

                return fileTypeExt;
            }
        },
    }
</script>

<style scoped>
    .profile {
        width: 42px;
        height: 42px;
        margin-right: 10px;
    }
    .profile img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .carousel img {
        max-height: 100%;
        width: auto !important;
        height: calc(70vh - 70px);
    }
</style>

<style>
    /*.carousel-item {*/
        /*height: calc(100vh - 100px);*/
    /*}*/

    /*.carousel-caption {*/
        /*position: unset;*/
        /*max-height: 100%;*/
        /*overflow: auto;*/
    /*}*/
</style>